<div>
  <!--ADYEN FORM-->
  <div class="display-utils-row display-utils-lt-md-col display-utils-start-center"
    *ngIf="stackingOnePackageMessage">
    <div class="display-utils-center-center display-utils-gap-20 display-utils-flex-100">
      <div class="warning-stacking-one-card">
        <div class="display-utils-row display-utils-center-center display-utils-gap-16 display-utils-sm-gap-8 display-utils-md-gap-16">
          <img src="../../../assets/images/dialog-icons/warn-badge.svg">
          <div class="display-utils-row display-utils-lt-sm-col display-utils-center-center display-utils-xs-start-start display-utils-gap-16 display-utils-xs-gap-4 display-utils-sm-gap-8 display-utils-md-gap-12">
            <span>
              <strong>Atenção</strong>
            </span>
            <p [innerHTML]="stackingOnePackageMessage"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <form *ngIf="this.endPromise" [formGroup]="paymentAdyenForm" (ngSubmit)="onAdyenSubmit()">
    <!--  Abas de forma de pagamento (Cartão de Crédito / Boleto bancário / PIX -->
    <mat-tab-group fitInkBarToContent mat-align-tabs="start" animationDuration="0ms"
      [(selectedIndex)]="this.selectedIndex" (selectedIndexChange)="storePaymentMethod(selectedIndex)" *ngIf="this.context === 'SALE' || this.context === 'UPGRADE' ||
            this.context === 'RETENTION' || this.context === 'PAYMENT_CHANGE' ||
            this.context === 'ACTIVATE_AUTO_RECHARGE' || this.context === 'AUTO_RECHARGE_PAYMENT_CHANGE'">

      <ng-container *ngFor="let tab of tabOrder">
        <mat-tab [label]="tab" [disabled]="this.submitting">
          <ng-container [ngSwitch]="tab">

            <ng-container *ngSwitchCase="'CREDIT_CARD'">
              <ng-template mat-tab-label>
                Cartão de crédito
              </ng-template>


              <div *ngIf="showCreditCardForm">
                <!--Adyen Component-->
                <pme-adyen-custom-card [hideConditions]="this.hideConditions" [hasInstallment]="hasInstallment"
                  [availablePaymentOptions]="this.availablePaymentOptions" (selectedOptionInstallment)="this.recieveSelectedOptionMSG($event)"></pme-adyen-custom-card>
                <div *ngIf="haveSavedCreditCard">
                  <p class="handleRegisteredCreditCards" (click)="handleRegisteredCreditCards()">
                    <mat-icon (click)="handleRegisteredCreditCards()">arrow_back</mat-icon>
                    Voltar para cartões salvos
                  </p>
                </div>
              </div>

              <div *ngIf="!showCreditCardForm && haveSavedCreditCard">
                <pme-registered-credit-cards [creditCardsData]="this.creditCardsData"
                  [maxLimitCreditCards]="this.maxLimitCreditCards"
                  [availablePaymentOptions]="this.availablePaymentOptions"
                  [isACreditCardError]="this.isACreditCardError" [hiddenAdobeDtm]="this.hiddenAdobeDtm"
                  [paymentData]="this.paymentData" [adyenCardError]="this.adyenCardError"
                  [suggestionMessage]="this.suggestionMessage"
                  (handleIstallmentsPayment)="handleUpdatePaymentConditionIdentifier($event)"
                  (handlePaymentConditionInstallmentsPayment)="handlePaymentConditionInstallment($event)"
                  (deleteCreditCard)="handleDeleteCreditCard($event)" (selectDefaultCard)="setDefaultCard($event)"
                  (changeCreditCard)="this.changeCreditCard()">
                </pme-registered-credit-cards>
              </div>

            </ng-container>

            <ng-container *ngSwitchCase="'PIX'">
              <ng-template mat-tab-label>
                PIX
              </ng-template>
              <div class="payment-method-container ">
                <div class="title-payment-method-container">
                  <div class="pix-image">
                    <img id="pix" src="/assets/images/payment-methods/pixCheckin.png">
                  </div>
                  <p class="pix-checkin-info">Ao gerar o código PIX do pedido, você poderá pagar escaneando o QR Code ou
                    Copiar e colar o código.</p>
                  <mat-divider inset></mat-divider>
                  <p class="payment-method-info-instruction"> Clique no botão <strong>"Finalizar compra"</strong> para
                    gerar o código PIX. </p>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'BANK_BILLET'">
              <ng-template mat-tab-label>
                Boleto bancário&nbsp;
                <span class="pme-badge pme-badge-success" *ngIf="this.discountBadge">
                  {{(this.context === 'UPGRADE' ? '+' : '') + this.discountBadge}}</span>
              </ng-template>

              <mat-card class="pme-payment-choice-card" *ngIf="this.showBankBilletCard">
                <div class="display-utils-row display-utils-gap-8">
                  <!--<mat-radio-button value="Boleto Bancário"></mat-radio-button>-->
                  <div class="pme-payment-choice-card-content display-utils-row display-utils-between-center">
                    <div class="mat-h3">
                      <b>{{this.retentionBankBilletCart.product.name}}</b>
                    </div>
                    <div class="pme-text-right">
                      <div>
                        <span *ngIf="this.retentionBankBilletCart.totalValue !== this.retentionBankBilletCart.baseValue"
                          class="mat-small pme-payment-choice-card-price-from">
                          {{this.retentionBankBilletCart.baseValue | currency: 'R$'}}
                        </span>
                        <span class="mat-h3">{{this.retentionBankBilletCart.totalValue | currency: 'R$'}}</span>
                      </div>
                      <!--<div class="pme-dark-secondary-text">31,41 por mês</div>-->
                    </div>
                  </div>
                </div>
              </mat-card>
              <!-- End Escolher Forma de Pagamento -->

              <!-- Adicionar/Editar Forma de Pagamento -->
              <div class="payment-method-container">
                <div class="title-payment-method-container">
                  <div class="billet-image">
                    <img id="billet" src="/assets/images/payment-methods/billetCheckin.png">
                  </div>
                  <p class="payment-method-info">O prazo de compensação do boleto é de até <strong>3 dias úteis</strong>
                    após o pagamento.</p>
                  <div
                    *ngIf="this.productClassificationIdentifier === 'plano-mensal' || this.productClassificationIdentifier ===  'plano-mensal-recarga-pontual' || this.productClassificationIdentifier ===  'consulta-e-recuperacao-de-dividas'">
                    <p class="payment-method-info">
                      {{this.paymentChangeMessage || 'Após o pagamento, seus créditos serão adicionados
                      automaticamente.'}}
                    </p>

                  </div>
                  <mat-divider inset></mat-divider>
                  <p class="payment-method-info-instruction"> Clique no botão <strong>"Finalizar compra"</strong> para
                    gerar o boleto. </p>

                </div>
              </div>
              <!-- End - Adicionar/Editar Forma de Pagamento -->


            </ng-container>


          </ng-container>
        </mat-tab>
      </ng-container>


    </mat-tab-group>

    <!-- Payload do Fraudnet coletado pelo JSC e salvo neste campo -->
    <textarea id="prefs_se" name="payloadArea" rows="5" cols="50" style="display: none;"></textarea>

    <pme-alert type="info" *ngIf="this.context === 'CAMPAIGN' || (this.context === 'SALE' && this.campaignMessage)">
      {{this.campaignMessage}}
    </pme-alert>

    <pme-alert type="error" title="Ops!"
      *ngIf="this.paymentFormValidationErrors && this.paymentFormValidationErrors.length && (isACreditCardError===false || this.formsOpened)">
      <div *ngFor="let error of this.paymentFormValidationErrors" [innerHTML]="error">{{error}}</div>
    </pme-alert>

    <!-- Ativar recarga automática e salvar cartão -->
    <!-- Ainda não funciona -->

    <div class="slider-toggle" *ngIf="this.paymentData.identifier === 'CREDIT_CARD'">
      <mat-slide-toggle *ngIf="this.cartService.carts &&
      ((this.cartService.carts.length === 1 &&
      this.cart.paymentMethod.identifier === 'CREDIT_CARD' &&
      this.productClassificationIdentifier.includes('consulta-e-recuperacao-de-dividas')) ||
      (this.cartService.carts.length > 1 &&
      this.cart.product.automaticRecharge &&
      !this.cart.allowSaleWithoutPayment))" [ngModel]="this.allowAutomaticRecharge"
        (change)="onAutomaticRechargeClick($event)" [formControl]="automaticRechargeFormControl"
        aria-label="'Recarga garantida desativada'" [disabled]="this.submitting">Ativar recarga garantida<p>Quando seu
          crédito for igual ou menor que R$ {{automaticRechargeValueFormat()}}, será feita uma nova recarga no valor do
          pacote
          escolhido.</p>
      </mat-slide-toggle>

      <mat-slide-toggle *ngIf="showCreditCardForm" [disabled]="this.submitting" [(ngModel)]="this.saveCreditCard"
        [ngModelOptions]="{standalone: true}" (change)="handleSaveCardChange()">
        Lembrar cartão nas próximas compras
      </mat-slide-toggle>
      <mat-slide-toggle *ngIf="this.saveCreditCard && showCreditCardForm" [disabled]="this.submitting"
        [(ngModel)]="this.defaultCard" [ngModelOptions]="{standalone: true}" (change)="handleDefaultCard()">
        Definir como cartão padrão
      </mat-slide-toggle>

    </div>
    <!-- End Ativar recarga automática e salvar cartão -->

    <mat-card *ngIf="this.showAutomaticRechargeOnlyMessage">
      <mat-card-content>
        <div class="display-utils-row display-utils-between-start display-utils-gap-8">
          <div class="pme-dark-secondary-text mat-body">
            <b>{{this.cart.messages.automaticRechargeOnly}}</b>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <div class="pme-new-form-terms mat-caption" *ngIf="this.termOfUse && this.context !== 'CAMPAIGN'">
      Ao clicar no botão "Finalizar compra" você confirma que está de acordo com os <a href="{{this.termOfUse}}"
        target="_blank" rel="noreferrer">Termos de Uso</a>.
    </div>

    <div class="display-utils-row display-utils-center-center display-utils-gap-20">
      <a *ngIf="returnUrl" (click)="navigateToReturnUrl()">Alterar Plano</a>
      <!-- <a *ngIf="this.redirectUrl && !returnUrl && !isACreditCardError" href="{{this.redirectUrl}}">Voltar</a> -->

      <button mat-flat-button  type="submit" class="pme-btn-lg btn-success"
        [disabled]="this.context !== 'CAMPAIGN' && (this.disableSubmit || submitting || (this.disableSubmitCreditCard && this.paymentData.identifier !== 'BANK_BILLET' && this.paymentData.identifier !== 'PIX') ||
          ((this.context !== 'RETENTION') && ((!this.paymentForm.valid ) && this.paymentData.identifier !== 'BANK_BILLET' && this.paymentData.identifier !== 'PIX'))) ||
            (isBraspagError && isCreditCardEqual && !braspagTryAgainErrors && this.paymentData.identifier !== 'BANK_BILLET' && this.paymentData.identifier !== 'PIX') ||
            (this.isAdyen && this.adyenCustomCardComponent && !this.adyenCustomCardComponent.isValid) || (this.paymentData.sameCard && !this.paymentData.paymentConditionIdentifier && this.paymentData.identifier !== 'BANK_BILLET' && this.paymentData.identifier !== 'PIX') || (this.paymentData.identifier !== 'BANK_BILLET' && this.paymentData.identifier !== 'PIX' && this.registeredCreditCardsComponent && !this.registeredCreditCardsComponent.selectedRadioButton && !this.showCreditCardForm)"
        (click)="onButtonClick()">
        <div class="display-utils-row display-utils-center-center display-utils-gap-8">
          <mat-spinner *ngIf="submitting" diameter="20" aria-label="Carregando"></mat-spinner>
          <div>{{this.buttonName}}</div>
        </div>
      </button>
    </div>
  </form>
</div>
